import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import './App.css';
import './index.css';
import WorkshopPage from './pages/Workshop';
import InternPage from './pages/InternPage';
import FAQPage from './pages/FAQPage';
import ShopPage from './pages/ShopPage';
import AboutPage from './pages/AboutPage';
import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import NavBar from './components/NavBar';
import Footer from "./components/Footer";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/workshop" element={<WorkshopPage />} />
        <Route path="/intern" element={<InternPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/blogs" element={<BlogPage />} />
        <Route path="/blogs/:slug" element={<BlogPost />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
